import { ControlledCheckbox } from "@dune/ui";
import { RENOVATION_OR_EXTENSION_ACTION_TYPES } from "@dune/vars";
import { useFormContext, useWatch } from "react-hook-form";
import { useEffect, useRef } from "react";

const RenovationOrExtensionDetailsContainer = () => {
	const { control, setValue, watch } = useFormContext();

	const actionsValue = useWatch({
		control,
		name: "actions",
	});

	const underpinningExistingFoundations = watch(
		"actions.underpinningExistingFoundations",
	);
	const prevUnderpinningRef = useRef(underpinningExistingFoundations);

	useEffect(() => {
		if (underpinningExistingFoundations) {
			setValue("actions.interventionOnLoadBearingStructure", true, {
				shouldDirty: false,
			});
		} else if (
			prevUnderpinningRef.current === true &&
			underpinningExistingFoundations === false
		) {
			setValue("actions.interventionOnLoadBearingStructure", false, {
				shouldDirty: false,
			});
		}
		prevUnderpinningRef.current = underpinningExistingFoundations;
	}, [underpinningExistingFoundations, setValue]);

	const displayMessage = () => {
		if (!actionsValue || actionsValue.length === 0) {
			return "";
		}

		const hasRenovation =
			actionsValue.types.includes("RENOVATION") ||
			actionsValue.types.includes("SYNDIC");
		const hasExtension = actionsValue.types.includes("EXTENSION");

		if (hasRenovation && hasExtension) {
			return "La rénovation ou l'extension prévoit";
		}
		if (hasRenovation) {
			return "La rénovation prévoit";
		}
		if (hasExtension) {
			return "L'extension prévoit";
		}

		return "";
	};

	return (
		<div className="flex flex-col gap-4">
			{displayMessage()}
			{Object.keys(RENOVATION_OR_EXTENSION_ACTION_TYPES).map((key) => {
				const isInterventionOnLoadBearing =
					key === "interventionOnLoadBearingStructure";
				const isDisabled =
					isInterventionOnLoadBearing && underpinningExistingFoundations;

				return (
					<ControlledCheckbox
						id={key}
						key={key}
						control={control}
						name={`actions.${key}`}
						label={
							RENOVATION_OR_EXTENSION_ACTION_TYPES[
								key as keyof typeof RENOVATION_OR_EXTENSION_ACTION_TYPES
							]
						}
						disabled={isDisabled}
					/>
				);
			})}
		</div>
	);
};

export default RenovationOrExtensionDetailsContainer;
